/**
 * Custom hook untuk mengambil detail inventory berdasarkan ID
 * 
 * API Endpoint: GET `/api/v4/inventory/:id`
 * 
 * @param {string} id - ID inventory
 * @returns {object} - Return value berupa object dengan key `data`, `isLoading`, dan `error`.
 */

import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { InventoryResponseSchema } from "../response/ShowInventoryResponse";

interface ShowInventoryProps {
    id?: string;
}

const useShowInventory = ({ id }: ShowInventoryProps) => {
    return useQuery({
        queryKey: ['inventories', id],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/v4/inventory/${id}`);

                // Validasi response
                const validationResult = InventoryResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid inventory data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch inventory`, error);
                throw error;
            }
        },
        enabled: !!id,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useShowInventory;
